/* CCC Courier theme v1.3.8 — route tools
   - Route preview in the hero price checker: a small map with the van driving the route
   - "Is it worth driving there yourself?" calculator
   Postcodes: postcodes.io (free, no key). Driving route and map tiles: Geoapify,
   using the browser key from Theme settings > Booking (restricted to your domain).
   The map is drawn without a library (tiles + SVG) to keep the page light.
   Without a key it falls back to a straight-line estimate and no map. */
(function () {
  'use strict';
  var CCC = window.CCC = window.CCC || {};
  if (CCC.routeTools) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cache = {};

  function esc(s) { return CCC.escapeHtml ? CCC.escapeHtml(String(s == null ? '' : s)) : String(s == null ? '' : s); }
  function clean(pc) { return String(pc || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function store(k, v) { try { sessionStorage.setItem('ccc-route:' + k, JSON.stringify(v)); } catch (e) { /* ignore */ } }
  function recall(k) { try { return JSON.parse(sessionStorage.getItem('ccc-route:' + k) || 'null'); } catch (e) { return null; } }

  /* ---------- Postcode lookup (postcodes.io) ---------- */
  function lookup(pc) {
    var c = clean(pc);
    if (!c) return Promise.reject({ kind: 'invalid' });
    if (cache['pc' + c]) return cache['pc' + c];
    var full = CCC.postcode && CCC.postcode.isValid(pc);
    var url = full ? 'https://api.postcodes.io/postcodes/' + c : 'https://api.postcodes.io/outcodes/' + c;
    cache['pc' + c] = fetch(url).then(function (res) {
      if (res.status === 404) throw { kind: 'notfound', postcode: pc };
      if (!res.ok) throw { kind: 'error' };
      return res.json();
    }).then(function (j) {
      var r = j && j.result;
      if (!r || r.latitude == null) throw { kind: 'notfound', postcode: pc };
      var d = r.admin_district;
      return { lat: r.latitude, lon: r.longitude, place: (Array.isArray(d) ? d[0] : d) || '' };
    });
    cache['pc' + c].catch(function () { delete cache['pc' + c]; });
    return cache['pc' + c];
  }

  /* ---------- Driving route ---------- */
  function haversine(a, b) {
    var R = 6371000, toRad = Math.PI / 180;
    var dLat = (b.lat - a.lat) * toRad, dLon = (b.lon - a.lon) * toRad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * toRad) * Math.cos(b.lat * toRad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function estimate(a, b) {
    var metres = haversine(a, b) * 1.25;
    var miles = metres / 1609.344;
    return { metres: metres, seconds: (miles / 45) * 3600, coords: [[a.lon, a.lat], [b.lon, b.lat]], approx: true };
  }

  function route(fromPc, toPc, key) {
    var k = clean(fromPc) + '-' + clean(toPc);
    var saved = recall(k);
    if (saved) return Promise.resolve(saved);
    return Promise.all([lookup(fromPc), lookup(toPc)]).then(function (pts) {
      var a = pts[0], b = pts[1];
      var base = { from: a, to: b };
      if (!key) return Object.assign(base, estimate(a, b));
      var url = 'https://api.geoapify.com/v1/routing?waypoints=' + a.lat + ',' + a.lon + '|' + b.lat + ',' + b.lon + '&mode=drive&apiKey=' + encodeURIComponent(key);
      return fetch(url).then(function (res) {
        if (!res.ok) throw new Error('routing');
        return res.json();
      }).then(function (j) {
        var f = j && j.features && j.features[0];
        if (!f) throw new Error('routing');
        var g = f.geometry || {};
        var coords = g.type === 'MultiLineString' ? [].concat.apply([], g.coordinates) : (g.coordinates || []);
        return Object.assign(base, { metres: f.properties.distance, seconds: f.properties.time, coords: thin(coords, 400), approx: false });
      }).catch(function () { return Object.assign(base, estimate(a, b)); });
    }).then(function (r) { store(k, r); return r; });
  }

  function thin(coords, max) {
    if (coords.length <= max) return coords;
    var step = coords.length / max, out = [];
    for (var i = 0; i < max; i++) out.push(coords[Math.floor(i * step)]);
    out.push(coords[coords.length - 1]);
    return out;
  }

  /* ---------- Formatting ---------- */
  function miles(m) { return Math.round(m / 1609.344); }
  function duration(sec) {
    var mins = Math.round(sec / 60);
    if (mins < 60) return mins + ' min';
    var h = Math.floor(mins / 60), m = mins % 60;
    return h + ' h' + (m ? ' ' + m + ' min' : '');
  }
  function hoursPhrase(sec) {
    var mins = Math.round(sec / 60);
    if (mins < 60) return mins + ' minutes';
    var h = Math.round(mins / 30) / 2;
    return (h % 1 ? h.toFixed(1) : h) + (h === 1 ? ' hour' : ' hours');
  }
  function money(n) { return '£' + Math.round(n).toLocaleString('en-GB'); }

  /* ---------- Map: Geoapify raster tiles + SVG route, no library ---------- */
  var VAN = '<svg viewBox="0 0 46 28" width="46" height="28" aria-hidden="true"><path d="M3 6.5A3.5 3.5 0 0 1 6.5 3H29v18H3z" fill="#F8F8EE" stroke="#1C2421" stroke-width="1.6" stroke-linejoin="round"/><path d="M29 8h7.5l6 7.2V21H29z" fill="#4D6863" stroke="#1C2421" stroke-width="1.6" stroke-linejoin="round"/><path d="M31.5 10.2h4.2l3.6 4.6h-7.8z" fill="#E3E9E6"/><circle cx="10" cy="22.5" r="3.4" fill="#1C2421"/><circle cx="35" cy="22.5" r="3.4" fill="#1C2421"/><circle cx="10" cy="22.5" r="1.3" fill="#F8F8EE"/><circle cx="35" cy="22.5" r="1.3" fill="#F8F8EE"/><path d="M8 9.5h16" stroke="#4D6863" stroke-width="2.2" stroke-linecap="round"/><path d="M8 14h11" stroke="#4D6863" stroke-width="2.2" stroke-linecap="round"/></svg>';
  var TILE = 256;

  function project(lat, lon, z) {
    var size = TILE * Math.pow(2, z);
    var sin = Math.sin(lat * Math.PI / 180);
    return [(lon + 180) / 360 * size, (0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI)) * size];
  }

  function drawMap(el, r, key) {
    if (!el || !key) return Promise.resolve(null);
    if (el._ccc) el._ccc.stop();
    var W = el.clientWidth || 320, H = el.clientHeight || 170, PAD = 30;
    /* Fit the route: work out a fractional zoom, then scale the nearest tile level to match */
    var base = r.coords.map(function (c) { return project(c[1], c[0], 0); });
    var bxs = base.map(function (p) { return p[0]; }), bys = base.map(function (p) { return p[1]; });
    var bw0 = Math.max(Math.max.apply(null, bxs) - Math.min.apply(null, bxs), 1e-9);
    var bh0 = Math.max(Math.max.apply(null, bys) - Math.min.apply(null, bys), 1e-9);
    var zf = Math.log(Math.min((W - PAD * 2) / bw0, (H - PAD * 2) / bh0)) / Math.LN2;
    zf = Math.max(3, Math.min(13, zf));
    var z = Math.floor(zf), ts = TILE * Math.pow(2, zf - z), scale = Math.pow(2, zf);
    var px = base.map(function (p) { return [p[0] * scale, p[1] * scale]; });
    var minX = Math.min.apply(null, px.map(function (p) { return p[0]; })), maxX = Math.max.apply(null, px.map(function (p) { return p[0]; }));
    var minY = Math.min.apply(null, px.map(function (p) { return p[1]; })), maxY = Math.max.apply(null, px.map(function (p) { return p[1]; }));
    var ox = (minX + maxX) / 2 - W / 2, oy = (minY + maxY) / 2 - H / 2;
    var pts = px.map(function (p) { return [p[0] - ox, p[1] - oy]; });

    var n = Math.pow(2, z), retina = (window.devicePixelRatio || 1) > 1 ? '@2x' : '';
    var tiles = '';
    for (var tx = Math.floor(ox / ts); tx <= Math.floor((ox + W) / ts); tx++) {
      for (var ty = Math.floor(oy / ts); ty <= Math.floor((oy + H) / ts); ty++) {
        if (ty < 0 || ty >= n) continue;
        var wx = ((tx % n) + n) % n;
        tiles += '<img class="route-map__tile" alt="" draggable="false" style="left:' + (tx * ts - ox).toFixed(2) + 'px;top:' + (ty * ts - oy).toFixed(2) + 'px;width:' + (ts + 0.5).toFixed(2) + 'px;height:' + (ts + 0.5).toFixed(2) + 'px" src="https://maps.geoapify.com/v1/tile/positron/' + z + '/' + wx + '/' + ty + retina + '.png?apiKey=' + encodeURIComponent(key) + '">';
      }
    }
    var d = pts.map(function (p, i) { return (i ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1].toFixed(1); }).join('');
    var a = pts[0], b = pts[pts.length - 1];
    el.innerHTML = tiles +
      '<svg class="route-map__line" width="' + W + '" height="' + H + '" viewBox="0 0 ' + W + ' ' + H + '" aria-hidden="true">' +
        '<path d="' + d + '" fill="none" stroke="#1C2421" stroke-opacity=".14" stroke-width="7" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="' + d + '" fill="none" stroke="#4D6863" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"' + (r.approx ? ' stroke-dasharray="6 8"' : '') + '/>' +
      '</svg>' +
      '<span class="route-pin" style="left:' + a[0] + 'px;top:' + a[1] + 'px"><span>A</span></span>' +
      '<span class="route-pin" style="left:' + b[0] + 'px;top:' + b[1] + 'px"><span>B</span></span>' +
      '<span class="route-van" data-van><span class="route-van__body">' + VAN + '</span></span>' +
      '<span class="route-map__credit">Powered by <a href="https://www.geoapify.com/" target="_blank" rel="noopener">Geoapify</a> | &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a></span>';

    var van = el.querySelector('[data-van]');
    var cum = [0];
    for (var i = 1; i < pts.length; i++) cum.push(cum[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
    var total = cum[cum.length - 1] || 1;
    var raf = null, stopped = false, start = null, DURATION = 4200, PAUSE = 1600;

    function at(dist) {
      var lo = 0, hi = cum.length - 1;
      while (hi - lo > 1) { var mid = (lo + hi) >> 1; if (cum[mid] < dist) lo = mid; else hi = mid; }
      var seg = cum[hi] - cum[lo] || 1, t = (dist - cum[lo]) / seg;
      return { x: pts[lo][0] + (pts[hi][0] - pts[lo][0]) * t, y: pts[lo][1] + (pts[hi][1] - pts[lo][1]) * t, west: pts[hi][0] < pts[lo][0] };
    }
    function place(p) {
      van.style.transform = 'translate(' + p.x.toFixed(1) + 'px,' + p.y.toFixed(1) + 'px)';
      van.classList.toggle('is-west', p.west);
    }
    function frame(ts) {
      if (stopped) return;
      if (!start) start = ts;
      var t = (ts - start) / DURATION;
      if (t >= 1 + PAUSE / DURATION) { start = ts; t = 0; }
      var k = Math.min(t, 1);
      var eased = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      place(at(eased * total));
      raf = requestAnimationFrame(frame);
    }
    if (reduceMotion) place(at(total));
    else raf = requestAnimationFrame(frame);

    el._ccc = { stop: function () { stopped = true; if (raf) cancelAnimationFrame(raf); } };
    /* Redraw if the box changes width (phone rotation, layout shifts) */
    if (window.ResizeObserver && !el._cccRO) {
      var lastW = W;
      el._cccRO = new ResizeObserver(function () {
        if (Math.abs((el.clientWidth || 0) - lastW) > 8 && el._cccRoute) { lastW = el.clientWidth; drawMap(el, el._cccRoute, el._cccKey); }
      });
      el._cccRO.observe(el);
    }
    el._cccRoute = r; el._cccKey = key;
    return Promise.resolve(el);
  }

  CCC.routeTools = { lookup: lookup, route: route, drawMap: drawMap, miles: miles, duration: duration, hoursPhrase: hoursPhrase, money: money };

  /* ---------- Hero price checker: route preview ---------- */
  function initPreview(box) {
    if (box.dataset.ready) return;
    box.dataset.ready = 'true';
    var form = box.closest('[data-quote]');
    if (!form) return;
    var from = form.querySelector('[name="from"]');
    var to = form.querySelector('[name="to"]');
    var mapEl = box.querySelector('[data-route-map]');
    var meta = box.querySelector('[data-route-meta]');
    var key = box.getAttribute('data-geo-key') || '';
    var timer = null, lastKey = '';

    if (!key && mapEl) mapEl.remove();

    function check() {
      var f = from.value.trim(), t = to.value.trim();
      var valid = CCC.postcode.isValid(f) && CCC.postcode.isValid(t);
      var rc = valid ? CCC.checkRoute(f, t, 'ew') : { ok: false };
      if (!valid || !rc.ok) { box.hidden = true; lastKey = ''; return; }
      var k = clean(f) + '-' + clean(t);
      if (k === lastKey) return;
      lastKey = k;
      box.hidden = false;
      box.classList.add('is-loading');
      meta.textContent = 'Plotting the route…';
      route(f, t, key).then(function (r) {
        if (lastKey !== k) return;
        box.classList.remove('is-loading');
        var names = [r.from.place, r.to.place].filter(Boolean);
        meta.innerHTML = (names.length === 2 ? '<strong>' + esc(names[0]) + ' → ' + esc(names[1]) + '</strong> · ' : '') +
          (r.approx ? 'about ' : '') + miles(r.metres) + ' miles · ' + duration(r.seconds) + ' by road';
        if (mapEl) drawMap(mapEl, r, key).catch(function () { mapEl.remove(); mapEl = null; });
        CCC.track && CCC.track('ccc:route_preview', { miles: miles(r.metres) });
      }).catch(function (err) {
        if (lastKey !== k) return;
        box.classList.remove('is-loading');
        if (err && err.kind === 'notfound') meta.textContent = "We couldn't find " + CCC.postcode.format(err.postcode) + '. Check the postcode.';
        else box.hidden = true;
      });
    }
    function later() { clearTimeout(timer); timer = setTimeout(check, 450); }
    [from, to].forEach(function (i) { if (i) { i.addEventListener('input', later); i.addEventListener('blur', check); } });
    check();
  }

  /* ---------- "Is it worth driving there yourself?" ---------- */
  function initCalc(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var form = root.querySelector('[data-drive-form]');
    var from = form.querySelector('[name="from"]');
    var to = form.querySelector('[name="to"]');
    var bike = form.querySelector('[name="variant"]');
    var parking = form.querySelector('[name="parking"]');
    var btn = form.querySelector('[type="submit"]');
    var out = root.querySelector('[data-drive-result]');
    var key = root.getAttribute('data-geo-key') || '';
    var pence = parseFloat(root.getAttribute('data-pence')) || 55;
    var bookingUrl = root.getAttribute('data-booking-url');
    var niFrom = root.getAttribute('data-ni-from');
    var niUrl = root.getAttribute('data-ni-url');

    /* Default to a standard bike so the first result is meaningful */
    if (bike && !bike.value) {
      for (var i = 0; i < bike.options.length; i++) {
        if (/road/i.test(bike.options[i].getAttribute('data-title') || '')) { bike.selectedIndex = i; break; }
      }
    }

    function field(input, bad) {
      var f = input.closest('[data-field]');
      if (f) f.classList.toggle('is-invalid', bad);
      return bad;
    }
    function say(html, tone) {
      out.innerHTML = '<div class="notice' + (tone ? ' notice--' + tone : '') + '" role="status"><span>' + html + '</span></div>';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var f = from.value.trim(), t = to.value.trim();
      if (f) from.value = CCC.postcode.format(f);
      if (t) to.value = CCC.postcode.format(t);
      var bad = field(from, !CCC.postcode.isValid(f));
      bad = field(to, !CCC.postcode.isValid(t)) || bad;
      if (bad) { (CCC.postcode.isValid(f) ? to : from).focus(); return; }

      var rc = CCC.checkRoute(f, t, 'ew');
      if (rc.kind === 'ni') {
        say('Driving to or from Northern Ireland means a ferry crossing each way. We do the whole trip door to door from ' + esc(niFrom) +
          (niUrl ? '. <a href="' + esc(niUrl) + '">See Northern Ireland prices</a>' : '.'));
        return;
      }
      if (!rc.ok) { say(esc(CCC.routeMessage(rc.kind)), 'warn'); return; }

      var opt = bike && bike.options[bike.selectedIndex];
      var priceText = opt && opt.value ? opt.getAttribute('data-price') : '';
      var ours = parseFloat(String(priceText).replace(/[^0-9.]/g, '')) || 0;
      var extra = Math.max(0, parseFloat(parking && parking.value) || 0);

      btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true');
      out.classList.add('is-loading');
      route(f, t, key).then(function (r) {
        var tripMiles = miles(r.metres) * 2;
        if (tripMiles < 4) { say('Those two postcodes are only a few minutes apart, so it’s probably quickest to pop round yourself. For anything further, we’re here.'); return; }
        var tripSecs = r.seconds * 2;
        var running = tripMiles * pence / 100;
        var diy = running + extra;
        var save = diy - ours;
        var params = new URLSearchParams({ from: CCC.postcode.format(f), to: CCC.postcode.format(t) });
        if (opt && opt.value) params.set('variant', opt.value);
        var book = bookingUrl + (bookingUrl.indexOf('?') > -1 ? '&' : '?') + params.toString();

        var headline = save >= 1
          ? 'You save ' + hoursPhrase(tripSecs) + ' and ' + money(save) + '.'
          : 'You save ' + hoursPhrase(tripSecs) + ' behind the wheel.';
        var sub = save >= 1
          ? 'Driving there and back would cost about ' + money(diy) + '. We collect it from the seller for ' + esc(priceText) + ', insured and tracked.'
          : 'Driving works out about ' + money(-save) + ' cheaper, but that’s ' + hoursPhrase(tripSecs) + ' on the road. We collect it for ' + esc(priceText) + ', insured and tracked.';

        out.innerHTML =
          '<div class="drive-result">' +
            '<p class="drive-result__headline">' + headline + '</p>' +
            '<p class="drive-result__sub">' + sub + '</p>' +
            (key ? '<div class="drive-result__map route-map" data-drive-map></div>' : '') +
            '<div class="drive-result__compare">' +
              '<div class="drive-col drive-col--diy"><p class="drive-col__title">Drive there yourself</p><ul role="list">' +
                '<li><span>Round trip</span><strong>' + (r.approx ? '~' : '') + tripMiles + ' miles</strong></li>' +
                '<li><span>Time behind the wheel</span><strong>' + duration(tripSecs) + '</strong></li>' +
                '<li><span>Fuel and running costs</span><strong>' + money(running) + '</strong></li>' +
                (extra ? '<li><span>Parking and tolls</span><strong>' + money(extra) + '</strong></li>' : '') +
                '<li class="drive-col__total"><span>Total</span><strong>' + money(diy) + '</strong></li>' +
              '</ul></div>' +
              '<div class="drive-col drive-col--us"><p class="drive-col__title">Cycle Courier Co.</p><ul role="list">' +
                '<li><span>Collected from the seller</span><strong>Door to door</strong></li>' +
                '<li><span>Your time</span><strong>None</strong></li>' +
                '<li><span>Insured to full value</span><strong>Included</strong></li>' +
                '<li class="drive-col__total"><span>' + esc(opt ? (opt.textContent.split(' – ')[0] || 'Your price') : 'Your price') + '</span><strong>' + esc(priceText) + '</strong></li>' +
              '</ul></div>' +
            '</div>' +
            '<a class="btn btn--primary btn--lg btn--block" href="' + esc(book) + '">Book this collection</a>' +
            '<p class="drive-result__small">Running costs use the HMRC rate of ' + pence + 'p a mile, which covers fuel and wear. ' +
              (r.approx ? 'Distance is estimated. ' : 'Route by road from Geoapify. ') + 'Parking and tolls are whatever you add.</p>' +
          '</div>';
        if (key) drawMap(out.querySelector('[data-drive-map]'), r, key).catch(function () {});
        CCC.track && CCC.track('ccc:drive_calc', { miles: tripMiles, save: Math.round(save) });
      }).catch(function (err) {
        if (err && err.kind === 'notfound') say("We couldn't find " + esc(CCC.postcode.format(err.postcode)) + '. Check the postcode and try again.', 'warn');
        else say("We couldn't work out the route just now. Try again in a minute.", 'warn');
      }).then(function () {
        btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled');
        out.classList.remove('is-loading');
      });
    });
    [from, to].forEach(function (i) { i.addEventListener('input', function () { field(i, false); }); });
  }

  /* ---------- Route pages: draw the route once the map scrolls into view ---------- */
  function initAuto(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = 'true';
    var key = el.getAttribute('data-geo-key') || '';
    if (!key) { el.remove(); return; }
    function go() {
      route(el.getAttribute('data-from'), el.getAttribute('data-to'), key)
        .then(function (r) { return drawMap(el, r, key); })
        .catch(function () { el.remove(); });
    }
    if (!('IntersectionObserver' in window)) return go();
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); }
    }, { rootMargin: '200px' });
    io.observe(el);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-route-auto]').forEach(initAuto);
    (scope || document).querySelectorAll('[data-route-preview]').forEach(initPreview);
    (scope || document).querySelectorAll('[data-drive-calc]').forEach(initCalc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
